import React from "react";

/**
 * What a page shows while it is waiting for its data.
 *
 * Downloads takes two to three seconds to answer: the endpoint walks every release directory on the
 * server. Nothing was shown in that time, and a page that is blank for three seconds is read as a
 * page that is broken - the visitor leaves before it arrives. The test pages said "Loading results"
 * in plain text, which is honest but easy to miss halfway down a long page.
 *
 * A spinner rather than an hourglass cursor: a cursor does not exist on a touch screen, and it says
 * nothing about WHICH part of the page is still coming.
 */
export default function Loading({text = "Loading…"})
{
    return <div style={{display: "flex", alignItems: "center", gap: 10, padding: "24px 4px", color: "#666"}}>
        <style>{"@keyframes xmq-spin { to { transform: rotate(360deg) } }"}</style>
        <span style={{
            width: 18, height: 18, borderRadius: "50%",
            border: "2px solid #c8c8c8", borderTopColor: "#4a7ebb",
            animation: "xmq-spin 0.8s linear infinite",
            display: "inline-block", flex: "none"
        }}/>
        <span>{text}</span>
    </div>;
}
